import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { CenterFrameLayout } from 'Layouts';
import { useSubscription } from 'Hooks/useSubscription';
import { getSheerVerificationId } from 'Utils/SheerIdHelpers';

export function withSubscriptions(WrappedComponent) {
  function WithSubscriptionsHoc(props) {
    const location = useLocation();
    const { preSelectedPlan = '' } = useParams();
    const { isAuthenticated } = useSelector((s) => s.user);
    const { routes } = useSelector((s) => s.appConfig);
    const isBango = useSelector((s) => s.integrations.bango.subscriptionId);

    const { hasSubscription, isFetching, isStatusSuccess, isIAPUser, hasActiveSubscription } = useSubscription();

    // check: subscription
    if (isFetching && !isStatusSuccess) {
      return <CenterFrameLayout title="Checking your subscription" modernLayout showLoader />;
    }
    if (isAuthenticated) {
      // if hasSub
      if (isStatusSuccess) {
        if (hasSubscription && location.pathname.includes('signup-') && !isBango) {
          if (getSheerVerificationId()) {
            if (isIAPUser && hasActiveSubscription) {
              return (
                <Navigate
                  replace
                  to={{ search: location.search, pathname: routes.signupCurrentSubscriberMilitaryFirst }}
                />
              );
            }
            const param = preSelectedPlan ? '/' + preSelectedPlan : '';
            return <Navigate replace to={{ search: location.search, pathname: routes.changePlans + param }} />;
          }
          return <Navigate replace to={{ search: location.search, pathname: routes.signupCurrentSubscriber }} />;
        }
      }
    }
    return <WrappedComponent {...props} />;
  }
  return WithSubscriptionsHoc;
}
